import React, { useEffect, useState } from "react";
import { decodeToken, getToken } from "../../utils/TokenUtils";
import { API_URL, ENDPOINTS } from "../../constants/api";
import { useParams } from "react-router-dom";
import axios from "axios";

const StudentReceiptInvoice2 = () => {
  const { route,fee_id, id } = useParams();
  const token = getToken();
  const banner = decodeToken(token, "banner");
  const [data, setData] = useState([]);
  const [bannerLoaded, setBannerLoaded] = useState(false);

 
 
  useEffect(() => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/activityReport/${route}`;
    // console.log('url:', url);
    const getStudentInvoice = async () => {
      try {
        const response = await axios.post(
          url,
          { fee_id:fee_id,ref_no: id },
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          }
        );
        setData(response.data.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    getStudentInvoice();
  }, [route]);

  const header = data?.find((d) => d.title === 'header')?.fields || {};
  const itemsData = data?.find((d) => d.title === 'items');
  const items = Array.isArray(itemsData?.table)
    ? itemsData.table
    : itemsData?.fields
      ? [itemsData.fields]
      : [];

  const footer = data?.find((d) => d.title === 'footer')?.fields || {};
  console.log("footer index 0: ",footer);

  useEffect(() => {
  if (data.length > 0 && items.length > 0 && bannerLoaded) {
    const t = setTimeout(() => {
      window.print();
    }, 200);

    return () => clearTimeout(t);
  }
}, [data, items, bannerLoaded,fee_id,id]);



  const styles = {
    page: {
     
      backgroundColor: "white",
      padding: "12mm",
      boxSizing: "border-box",
      fontFamily: "Times New Roman",
      color: "#000",
      fontSize: "12px",
      lineHeight: 1.4,
    },
  //    page: {
  //   width: "210mm",       // A4 portrait width
  //   minHeight: "297mm",   // A4 portrait height
  //   backgroundColor: "white",
  //   padding: "12mm",
  //   boxSizing: "border-box",
  //   fontFamily: "Times New Roman",
  //   fontSize: "12px",
  //   lineHeight: 1.4,
  // },
    banner: {
      display: "block",
      margin: "auto",
      maxWidth: "95%",
      marginBottom: "10px",
    },
    headerRow: {
      display: "flex",
      justifyContent: "space-between",
      border: "1px solid #000",
      borderRadius: "4px",
      overflow: "hidden",
      marginBottom: "10px",
    },
    cell: {
      flex: 1,
      borderLeft: "1px solid #000",
      padding: "6px 8px",
      boxSizing: "border-box",
    },
    firstCell: {
      flex: 1,
      padding: "6px 12px",
      boxSizing: "border-box",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginBottom: "6px",
    },
    th: {
      border: "1px solid #000",
      padding: "4px 6px",
      textAlign: "left",
      fontWeight: "bold",
      fontSize: "12px",
    },
    td: {
      border: "1px solid #000",
      padding: "4px 6px",
      fontSize: "12px",
      verticalAlign: "top",
    },
    totalTd: {
      border: "1px solid #000", // lighter gray border like in PDF
      padding: "4px 6px",
      textAlign: "right",
      fontWeight: "bold",
    },
    lastTd: {
      border: "1px solid #999", // lighter gray border like in PDF
      padding: "4px 6px",
      textAlign: "right",
    },
    footer: {
      display: "flex",
      justifyContent: "space-between",
      fontWeight: "bold",
      marginTop: "15px",
    },
    divider: {
      borderTop: "1px dashed #000",
      margin: "18px 0",
    },
  };

  const Section = ({ label }) => (
    <>
    <style>
    {`
      @media print {
        @page {
          size: A4 portrait;
          margin: 12mm;
        }

        body {
          margin: 0;
        }
      }
    `}
  </style>
    <div>
      <img src={`${API_URL}/${header.banner}`} alt="Banner" style={styles.banner}
      onLoad={() => setBannerLoaded(true)}
  onError={() => setBannerLoaded(true)} />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "8px",
        }}
      >
        <div>
          <strong>Lacagta:</strong> {header.fee}
        </div>
        <div>
          <strong style={{ fontSize: "15px", fontWeight: "bolder" }}>
            {label}
          </strong>
        </div>
      </div>

      <div style={styles.headerRow}>
        {Object.entries(header).map(([key,val],index)=> key.toLocaleLowerCase()!='banner' && key.toLocaleLowerCase()!='fee' &&(
        <div style={index===0? styles.firstCell : styles.cell}>
          <strong>{key}:</strong> {val}
        </div>)
        )}
      </div>

     <table style={styles.table}>
  <thead>
    <tr>
      {Object.keys(items[0] || {}).map((header, idx) => (
        <th key={idx} style={styles.th}>
          {header}
        </th>
      ))}
    </tr>
  </thead>
  <tbody>
    {items?.map((row, i) => (
      <tr key={i}>
        {Object.values(row).map((val, idx) => (
          <td key={idx} style={styles.td}>
            {idx === 0 ? i + 1 : val}
          </td>
        ))}
      </tr>
    ))}

    {/* Total row */}
    <tr>
      <td
        colSpan={Object.keys(items[0] || {}).length - 1}
        style={{
          ...styles.td,
          textAlign: "center",
          fontWeight: "bold",
          borderRight: "none",
        }}
      >
        {Object.keys(footer)[0]}:
      </td>
      <td style={styles.totalTd}>
        { Object.values(footer)[0] || ""}
      </td>
     
    </tr>
  </tbody>
</table>


      <div style={styles.footer}>
        <div>{footer.signature1}: ________________________</div>
        <div>{footer.signature2}: ________________________</div>
      </div>
    </div>
    </>
  );

  return (
    <div style={styles.page}>
      <Section label="Original" />
      <div style={styles.divider}></div>
      <Section label="Copy" />
      <div style={styles.divider}></div>
    </div>
  );
};

export default StudentReceiptInvoice2;
